const hplcMsTicNegJcamp = `
##TITLE=Spectrum
##JCAMP-DX=5.00 $$ chemotion-converter-app (1.8.0)
##DATA TYPE=MASS TIC
##DATA CLASS=XYPOINTS
##ORIGIN=
##OWNER=
##XUNITS=MINUTES
##YUNITS=COUNTS
##SOFTWARE=openlab
##SCAN_MODE=negativ
##TYPE=ms chromatogramm
##FIRSTX=0.004666666666666667
##LASTX=9.997333333333334
##MINX=0.004666666666666667
##MAXX=9.997333333333334
##MINY=220.02685351092623
##MAXY=13179.64527027027
##NPOINTS=1200
##FIRSTY=13179.64527027027
##XUNITS=MINUTES
##YUNITS=COUNTS
##XYDATA=(XY..XY)
0.004666666666666667, 13179.64527027027
0.0133, 1118.7286337380644
0.021633333333333334, 4664.570681835652
0.029966666666666666, 4602.65455319753
0.0383, 4216.229180546303
0.04663333333333333, 5053.640940858195
0.05496666666666667, 5588.3330719774185
0.0633, 3291.758241758242
0.07163333333333334, 4864.118838622552
0.07996666666666667, 4876.747149564051
0.0883, 4377.260170768458
0.09663333333333333, 4592.7988860155165
0.10496666666666667, 4608.385731183465
0.1133, 5680.037520252408
0.12163333333333333, 5329.44218113444
0.12995, 4574.983178576234
0.13828333333333334, 4483.936879165095
0.14661666666666667, 4226.923319659199
0.15495, 4628.52401273454
0.16328333333333334, 2610.1635184663096
0.17161666666666667, 4606.707578136149
0.17995, 4719.788430241159
0.18828333333333333, 4417.083664283823
0.1966166666666667, 4386.144035042515
0.20495, 4451.935395938394
0.21328333333333332, 3682.4148642429823
0.22161666666666666, 4895.910949568378
0.22995, 3835.3961756979656
0.23828333333333335, 5385.91492125345
0.24661666666666668, 4402.893005772587
0.25495, 3751.401497957331
0.2632833333333333, 4559.576757532282
0.2716166666666667, 4532.415340677275
0.27995, 5706.711928497766
0.28828333333333334, 4783.778781372622
0.29661666666666664, 4312.492933860938
0.30495, 5115.5939258459875
0.31328333333333336, 4235.085026705139
0.32161666666666666, 3994.217597471022
0.32995, 4422.195237131485
0.3382833333333333, 4048.3918128654973
0.3466166666666667, 4076.7541436464085
0.35501666666666665, 4157.745283634702
0.36335, 3948.836629031252
0.3716833333333333, 4199.659908436886
0.3800166666666667, 5655.238012508687
0.3883333333333333, 4915.378979076772
0.39668333333333333, 4490.0788741107335
0.4050166666666667, 4471.79558782463
0.41335, 4453.946884425807
0.42168333333333335, 4942.414645450332
0.43001666666666666, 4641.6420062220195
0.43835, 4243.853342918764
0.4466833333333333, 4190.05644811116
0.45503333333333335, 4743.7215864555565
0.46335, 4478.11868592382
0.4717, 4276.433976943207
0.4800333333333333, 5017.318710099853
0.48835, 3784.7289039136654
0.4967, 3355.0202611436293
0.5050333333333333, 4167.248940756709
0.5133666666666666, 3464.9150986691143
0.5217, 5784.931937172775
0.5300333333333334, 4453.892519970952
0.5383666666666667, 4851.854204716906
0.5467, 4865.42025948908
0.5550333333333334, 4186.460515858681
0.5633666666666667, 3766.440243511695
0.5717, 3990.32646507894
0.5800333333333333, 4742.975677214675
0.58835, 4331.332300542215
0.5966833333333333, 4897.298438159562
0.6050333333333333, 5148.307937632884
0.61335, 3839.993315508021
0.6217, 3689.8243243243246
0.6300333333333333, 2863.917723952326
0.6383500000000001, 4532.330289797539
0.6466833333333334, 4167.71414090218
0.6550333333333334, 3581.2245688819994
0.6633666666666667, 4644.574197648554
0.6717, 4354.501122377893
0.6800333333333334, 4063.2153438328396
0.6883666666666667, 4436.007446898536
0.6967, 4693.542600896861
0.7050333333333333, 5263.708810888252
0.7133666666666667, 4094.2360283290095
0.7217, 4668.313738386912
0.7300333333333333, 3859.444137168142
0.7383666666666666, 3675.870008552069
0.7467, 3945.315434374348
0.7550333333333333, 4958.619820122721
0.7633666666666666, 3867.9290838852094
0.7717000000000002, 3598.7668231611897
0.7800333333333334, 4035.249738037024
0.7883666666666667, 4724.345549738219
0.7967, 3855.3161371500473
0.8050333333333334, 4694.385432473445
0.8133666666666667, 3813.8947725154626
0.8217, 3072.2890698177102
0.8300333333333333, 2681.4618061916103
0.8383666666666667, 3277.5032794053345
0.8467, 3788.5970906960847
0.8550333333333333, 4093.33195918788
0.8633666666666666, 2723.9901071723
0.8717, 3494.2109508020435
0.8800333333333333, 3832.5302352156937
0.8883500000000001, 3384.2797164292106
0.8966833333333334, 2398.1107285248277
0.9050166666666667, 3385.8514001806684
0.91335, 5049.726860044625
0.9216833333333333, 4353.491806402439
0.9300166666666667, 3741.1233003708285
0.93835, 2984.105529365547
0.9466833333333333, 2840.4828486204324
0.9550333333333333, 2737.506048387097
0.9633666666666667, 3188.8116339026747
0.9717, 3326.0963392350827
0.9800333333333333, 3675.589832013111
0.9883666666666666, 3706.078828292451
0.9967, 2975.199168687219
1.0050333333333332, 4151.732480533927
1.0133666666666667, 3113.479420059933
1.0217, 3355.4215646534253
1.0300333333333334, 4015.233145330535
1.0383666666666667, 4828.557573620174
1.0466833333333334, 5118.009749638903
1.0550166666666667, 4780.385839902971
1.06335, 3908.3646344986996
1.0716833333333333, 4818.565670467951
1.0800333333333334, 4323.902937895128
1.08835, 4219.285447063226
1.0966833333333332, 3465.3034300791555
1.1050166666666668, 4507.704468802698
1.11335, 4038.6787072243346
1.1217, 4085.1480660757456
1.1300333333333332, 4599.833639284076
1.13835, 3564.9551066217737
1.1466833333333333, 5005.166892474443
1.1550166666666664, 4271.767426850258
1.16335, 5564.972803814917
1.1716833333333334, 6140.695417334797
1.1800166666666667, 5595.03412567663
1.18835, 4894.573082489146
1.1966833333333333, 5241.346548188653
1.2050166666666666, 5587.624437474431
1.21335, 4821.034246148088
1.2216833333333332, 5789.52482974979
1.2300166666666668, 5260.354944897666
1.23835, 4662.126163902078
1.2466833333333334, 5708.108974358974
1.2550166666666667, 5250.88181485547
1.26335, 5154.49823082135
1.2716833333333333, 5896.412871461227
1.2800166666666664, 5233.8979136192165
1.28835, 4842.843319687384
1.2966833333333334, 5556.1650485436885
1.3050166666666667, 5427.615947925143
1.31335, 5920.849981837995
1.3216833333333333, 4320.009798432251
1.3300166666666666, 3972.6980376714578
1.33835, 4833.536389868547
1.3466833333333332, 4963.678179470627
1.3550333333333333, 3717.0230658337337
1.3633666666666666, 4239.730145413871
1.3717, 4805.510998173589
1.3800333333333332, 1620.4263995167137
1.38835, 4660.942262474963
1.3966833333333333, 5229.627151051625
1.4050333333333334, 4911.433275404738
1.4133666666666664, 3840.950384346611
1.4217, 3671.8659068865177
1.4300333333333333, 6038.774009741752
1.4383666666666666, 5306.546080964686
1.4466833333333333, 4499.038808990388
1.4550333333333334, 3546.2435233160622
1.4633666666666667, 4833.11978545888
1.4717, 3955.753942395412
1.4800333333333333, 4170.067049808429
1.4884666666666666, 5158.629654478363
1.4968, 4871.887159533075
1.5051333333333334, 3654.252379490328
1.51345, 4480.787518573551
1.5217833333333333, 5484.811736770692
1.5301333333333333, 5347.459243843219
1.53845, 5342.1438241618225
1.5467833333333334, 5156.936282090937
1.5551166666666667, 4742.640375876145
1.56345, 4633.335924141147
1.5717833333333333, 4413.831366174288
1.5801166666666666, 5358.872810357959
1.5884499999999997, 5131.686643835616
1.5967833333333334, 4163.588465646138
1.6051166666666667, 3795.2113778705634
1.61345, 5394.0475081509085
1.6217833333333334, 4535.935688335781
1.6301333333333334, 4159.100032372936
1.63845, 4369.952881478796
1.6467833333333333, 4092.735956658112
1.6551166666666666, 5039.327108821636
1.66345, 5743.861964925513
1.6717833333333334, 4873.643960895617
1.6801166666666667, 4885.379880123117
1.68845, 4659.166601516691
1.6967833333333333, 4694.591176251767
1.7051166666666666, 4744.9508067689885
1.7134499999999997, 4029.7500508026824
1.7217833333333334, 5102.262443438914
1.7301166666666667, 4438.601348952787
1.73845, 5289.409113670506
1.7467833333333334, 5231.874575118966
1.7551166666666667, 4664.43856509221
1.76345, 4905.371043072133
1.7717833333333333, 5220.1820680178635
1.7801166666666666, 4885.875375877046
1.78845, 5122.868020304569
1.7967833333333334, 3211.93032427695
1.8051166666666667, 4063.372460813945
1.81345, 3871.236797274276
1.8217833333333333, 5630.918959386113
1.8301166666666666, 5471.932946244615
1.8384499999999997, 3383.080173595249
1.8467666666666667, 4487.255769076144
1.8551166666666667, 4655.067205409417
1.86345, 4633.279181220047
1.8717833333333334, 4580.879850238258
1.8801166666666667, 5470.038261552046
1.8884333333333336, 4921.146146146146
1.8967666666666667, 4466.608955693712
1.9051166666666666, 4107.0397360099
1.91345, 5209.900542495479
1.9217833333333334, 4317.547847767104
1.9301166666666667, 4935.83494411295
1.93845, 5665.934283452098
1.9467833333333333, 4650.492748978448
1.9551166666666666, 4621.569595261599
1.9634499999999997, 5481.744217935826
1.9717833333333334, 4748.648225060731
1.9801166666666667, 3725.263361985394
1.98845, 5284.810434219054
1.9967833333333334, 4784.125560538117
2.005116666666667, 3764.1232976653696
2.01345, 5244.604779411765
2.0217833333333335, 3643.8621546103695
2.030116666666667, 5690.090750756257
2.03845, 5008.417481218193
2.0467833333333334, 4186.517185425579
2.0551166666666667, 4330.355427473583
2.06345, 4479.116086356037
2.0717833333333333, 4827.243798955614
2.0801166666666666, 4661.634965600971
2.08845, 4367.8712871287125
2.0967666666666664, 4855.158970804817
2.1051166666666665, 5477.956382778718
2.11345, 5529.343963115935
2.121783333333333, 5605.343819318411
2.130116666666667, 4806.75194152581
2.13845, 6649.7685969071
2.1467833333333335, 4424.730675473776
2.155116666666667, 4945.282675877113
2.16345, 4192.943719601636
2.1717833333333334, 5154.010222134853
2.180116666666667, 5697.791251624079
2.18845, 4698.4128353316655
2.1967666666666665, 4519.900849858357
2.2051166666666666, 4086.232481450948
2.213433333333333, 4689.059923034635
2.221783333333333, 4331.2378281529955
2.2301166666666665, 4744.019269223778
2.23845, 4278.721664808621
2.246783333333333, 4357.541111981206
2.255116666666667, 4711.5720716744645
2.26345, 5175.984327217125
2.2717833333333335, 5634.461470620659
2.280116666666667, 5269.419787832864
2.28845, 3862.4284990225183
2.2967833333333334, 4185.228832028412
2.305116666666667, 4440.493206628446
2.31345, 3927.960206447752
2.3217833333333333, 4140.689865689866
2.3301166666666666, 3919.5083267248215
2.33845, 3430.3557100829103
2.346783333333333, 5672.177337911533
2.3551166666666665, 4539.320722269991
2.36345, 4556.800430918395
2.3718, 5731.207709657576
2.380133333333333, 5620.103775667918
2.3884666666666665, 3538.5236447520183
2.3967833333333335, 4664.499121265378
2.405133333333333, 5272.657342657342
2.413466666666667, 3989.80677052127
2.4218, 4396.24111653395
2.4301333333333335, 3633.0123319939034
2.4384666666666663, 5412.690129898968
2.4468, 4339.682670174285
2.4551333333333334, 3311.3879451365297
2.4634666666666667, 4216.652387257574
2.4718, 4205.224069541734
2.4801166666666665, 4577.688196394601
2.48845, 4782.272254280579
2.496783333333333, 3688.728165938865
2.505116666666667, 4892.036299657376
2.51345, 6307.364208118925
2.5217833333333335, 5085.515913237381
2.530133333333333, 4079.571209800919
2.53845, 4588.452109963229
2.5468, 5331.27144397608
2.5551333333333335, 4933.77127237457
2.5634666666666663, 5282.531451070778
2.5718, 4080.468018720749
2.5801333333333334, 5671.663309657585
2.58845, 5201.340066032239
2.596783333333333, 3886.587591240876
2.6051166666666665, 5004.075829383886
2.61345, 4497.767857142857
2.6218, 4095.706591822802
2.630133333333333, 4602.997713608265
2.63845, 3959.178452135598
2.6467833333333335, 3310.7718405428327
2.655116666666667, 2585.1062846580407
2.66345, 3060.1501305483025
2.6717833333333334, 3457.4956885932497
2.680116666666667, 3076.6774409273294
2.68845, 3747.5931726650897
2.6967833333333333, 3509.5520744094974
2.7051333333333334, 3456.50522317189
2.71345, 4053.135409123823
2.721783333333333, 3739.141515761234
2.7301333333333333, 3652.4448645242596
2.73845, 3819.4016140673184
2.746783333333333, 3918.930070427545
2.755116666666667, 4209.364026531408
2.76345, 3844.493331500069
2.7717833333333335, 3037.674064403829
2.780116666666667, 3935.575801749271
2.78845, 4672.877609496521
2.7967833333333334, 3656.934984520124
2.805116666666667, 4439.894992555442
2.81345, 3565.21287642783
2.8217833333333333, 3590.560975609756
2.8301166666666666, 3922.0235831114496
2.83845, 4145.785068630733
2.8467666666666664, 3694.291292001893
2.8551166666666665, 2725.602196245129
2.86345, 2139.356257208766
2.871783333333333, 2904.2760654490103
2.880116666666667, 2207.265180975172
2.88845, 1940.809958826557
2.8967666666666667, 2381.156538339166
2.905116666666667, 2264.4841856340527
2.9134333333333333, 2684.2457627118642
2.921766666666666, 2322.2257031467557
2.930116666666667, 2949.2626682501977
2.9384333333333332, 2717.2286317842054
2.9467666666666665, 2806.4239828693794
2.9551166666666666, 2688.3398564905415
2.963433333333333, 3296.5026478375994
2.9717666666666664, 3848.004866180049
2.9801166666666665, 3704.6043882978724
2.9884333333333335, 4238.19491183201
2.996783333333333, 3710.0789096126255
3.005116666666667, 3961.238837165115
3.01345, 3475.741616509028
3.0217833333333335, 3324.63190802743
3.030116666666667, 3063.766498447205
3.03845, 2934.303876244666
3.0467833333333334, 3751.6733680227057
3.055116666666667, 3566.803191489362
3.06345, 3814.356884057971
3.0717833333333333, 4159.3870192307695
3.0801166666666666, 3688.9753566796367
3.08845, 3279.5003888024885
3.096783333333333, 2579.394560923731
3.1051166666666665, 4300.864666579327
3.11345, 3478.726513569937
3.121783333333333, 3259.360058845163
3.130116666666667, 4442.9353778751365
3.13845, 3649.9634808013357
3.1467833333333335, 3423.733546071001
3.155116666666667, 3120.464801444043
3.1634333333333333, 3058.8398520084565
3.1717833333333334, 4210.949395432154
3.180116666666667, 3969.1000918273644
3.18845, 4000.1008064516127
3.1967833333333333, 3367.8018575851397
3.2051166666666666, 4715.764085412915
3.21345, 3025.7706962244542
3.221783333333333, 4288.28199617956
3.2301166666666665, 3601.157770800628
3.23845, 4196.324185631414
3.246783333333333, 3474.0698729582577
3.255116666666667, 3731.3124750099964
3.26345, 3621.0273972602736
3.2717833333333335, 2667.9051217464316
3.280116666666667, 4413.174273858921
3.28845, 3254.036501150937
3.2967833333333334, 3580.474824139208
3.305116666666667, 3275.791484716157
3.31345, 3306.1837029893927
3.3217833333333333, 3378.0503032465213
3.3301166666666666, 2767.208929092501
3.3384666666666667, 3214.3174820390013
3.346783333333333, 2603.696365127084
3.3551333333333333, 2849.4863013698628
3.36345, 3083.502834278093
3.371783333333333, 2936.063606360636
3.380116666666667, 3653.967889908257
3.38845, 3240.616500453309
3.3967833333333335, 3862.533512064343
3.405116666666667, 3505.814985795455
3.41345, 2481.4405762304923
3.4217833333333334, 2826.8573752711495
3.430116666666667, 3230.8880160197164
3.43845, 2497.7397021177567
3.4467666666666665, 3454.437394247039
3.4551, 2758.648851831602
3.463433333333333, 2460.9515632401703
3.471783333333333, 3066.322907222726
3.4801, 3220.9885817307695
3.4884333333333335, 3998.0532786885246
3.496766666666667, 2970.4889612227566
3.505116666666667, 3400.9343278991078
3.51345, 3626.651831564532
3.5217833333333335, 2620.91118505247
3.530116666666667, 3430.0231897067624
3.53845, 2519.702718006795
3.546766666666666, 3787.7962899347303
3.555116666666667, 3518.044792312461
3.56345, 3579.739165329053
3.5717833333333333, 3373.3811354228264
3.5801166666666666, 3674.142312579416
3.58845, 4236.210317460318
3.5967666666666664, 3221.0312166488798
3.6051, 4086.566235059761
3.6134333333333335, 3028.280786849906
3.621766666666667, 3232.5390329891716
3.630116666666667, 3347.7287754562285
3.6384333333333334, 3386.472017866526
3.6467666666666667, 3712.4298409728717
3.655116666666667, 3384.1538357644517
3.66345, 3339.897828863346
3.6717833333333334, 2958.7221953578332
3.680116666666667, 2816.9622684139176
3.68845, 1095.808458757252
3.6967833333333333, 968.2429621411733
3.7051166666666666, 2605.020241009226
3.71355, 3239.6775184275184
3.7219, 3437.193396226415
3.7302333333333335, 3565.816253914034
3.738566666666667, 3212.2166492965084
3.7468833333333333, 3552.5916265382557
3.7552333333333334, 3240.4118605817453
3.76355, 2932.934266997967
3.7718833333333333, 2881.7029872673847
3.7802166666666666, 3262.349397590361
3.78855, 3253.6542276221176
3.796883333333333, 4575.017464198393
3.8052166666666665, 3472.32729089352
3.8135666666666665, 3462.410239361702
3.8219, 2817.590149516271
3.830233333333333, 3116.848617176128
3.83855, 3704.277421326001
3.8469, 2846.494798733605
3.8552333333333335, 2718.541001064963
3.863566666666667, 2925.169579213612
3.8719000000000006, 3441.6553687635574
3.8802333333333334, 3167.2548657304756
3.8885666666666667, 2513.627202849644
3.8969, 2734.1318117836313
3.9052333333333333, 3429.5844653000745
3.9135666666666666, 2670.75315694528
3.9219, 3156.02700096432
3.9302333333333332, 2746.0886002326483
3.93855, 3465.308594746238
3.9468833333333335, 2823.3377518557795
3.955216666666667, 2831.7772317772315
3.96355, 3046.9780840488024
3.9719, 2781.707566462168
3.9802333333333335, 2505.60115350488
3.9885499999999996, 2964.922884535223
3.9968833333333333, 2668.5171855317617
4.005233333333333, 3269.080833700926
4.01355, 2946.059616169865
4.021883333333333, 1877.859604629991
4.030216666666667, 1643.0019520356943
4.03855, 2845.8780027794323
4.046883333333334, 3053.4152295865365
4.0552166666666665, 2695.9360820674688
4.06355, 2478.145365677046
4.071883333333333, 2290.752911813644
4.080216666666667, 2457.993496220777
4.08855, 2917.6254002134474
4.096866666666667, 2677.1328565672848
4.105216666666666, 3086.276536312849
4.11355, 2675.9888722648216
4.121883333333333, 3036.8621064060803
4.130233333333333, 2624.155717986677
4.13855, 2865.167589175892
4.146883333333333, 2246.6709656617763
4.155216666666667, 1968.5897435897434
4.16355, 2121.3973631764525
4.171883333333334, 3034.973963548968
4.180233333333334, 3269.9655254398476
4.18855, 2697.306956838463
4.196883333333333, 2914.635195304594
4.205216666666667, 2349.7563627577315
4.21355, 1773.9786223277908
4.221883333333333, 2718.395945140131
4.230216666666666, 2637.706204052358
4.23855, 3175.66705957994
4.246883333333333, 2462.2355896351137
4.255216666666667, 2276.418886962005
4.26355, 2822.218121424617
4.271883333333333, 2538.2937469704316
4.280216666666667, 3096.964212887439
4.28855, 2261.300121506683
4.296883333333333, 3133.0821572580644
4.305233333333334, 2180.697886042279
4.31355, 2400.4077371572644
4.321883333333333, 2240.957605612778
4.330216666666667, 3007.9180822952057
4.33855, 2929.1535760487895
4.346883333333333, 2467.68938264241
4.355216666666666, 1877.1607011971657
4.36355, 2871.8573385853742
4.371883333333333, 3142.497529644269
4.380216666666667, 2713.26150627615
4.38855, 2829.363805339642
4.396883333333333, 2444.54018826937
4.405216666666667, 2908.2545024558854
4.41355, 2793.0235975814576
4.421883333333333, 3001.929267443884
4.430233333333334, 2354.151605727791
4.43855, 2189.1311017180255
4.4469, 2663.508529276164
4.455233333333333, 2417.7745113011606
4.463566666666667, 2700.6695370516672
4.4719, 2409.2203241349102
4.4802333333333335, 2620.930276476809
4.488566666666666, 2456.6745826137017
4.4969, 2068.9656738103886
4.505233333333333, 2594.6107127176933
4.513566666666667, 2606.5606433850166
4.5219, 3142.647312198484
4.530233333333333, 2713.8598484848485
4.538566666666667, 2671.8467778968316
4.5469, 3039.361531038919
4.555233333333334, 2823.179611650485
4.563566666666666, 3012.5
4.5719, 3519.5142378559462
4.580233333333333, 1394.6568789178489
4.588566666666667, 1118.2593997361478
4.5969, 2266.7864304812833
4.6052333333333335, 2956.4351776068097
4.613566666666666, 2528.7625474769397
4.6219, 2553.091866863508
4.630233333333333, 2378.225047080979
4.63855, 2533.3078647106763
4.646883333333333, 2538.905345825296
4.655216666666667, 2424.2404570241497
4.66355, 2719.56598034628
4.671883333333333, 2795.03590384015
4.6802166666666665, 2558.478853521957
4.68855, 2917.09067436209
4.696883333333333, 2914.229215752272
4.705216666666667, 2301.2169939065675
4.71355, 2612.8813811579107
4.721883333333333, 2787.3994586233566
4.730216666666666, 2036.1010433827569
4.73855, 3331.7500930405654
4.746883333333333, 2644.0011199776004
4.755233333333333, 2667.58658008658
4.763566666666667, 2765.6589724497394
4.7719, 2709.948355011477
4.780233333333333, 3124.593855218855
4.78855, 2734.755719404631
4.796883333333333, 2919.306127295757
4.8052166666666665, 2565.9334084189777
4.81355, 2456.6154216535974
4.8219, 3224.6717346233586
4.830233333333333, 2263.6530364889
4.838566666666667, 3092.734971770176
4.8469, 2588.671360884443
4.8552333333333335, 2461.860697546181
4.863566666666666, 2929.45094217024
4.8719, 2894.6418317542348
4.880233333333333, 2813.050398895367
4.88855, 2246.602391916091
4.896883333333333, 2830.585459371774
4.905233333333333, 3017.4386814560226
4.913566666666667, 2586.059269893355
4.9219, 2801.004723555831
4.930233333333334, 3017.918289516391
4.938566666666666, 2592.588296398892
4.9469, 2524.9011605662545
4.955233333333333, 2235.788672350792
4.963566666666667, 2295.1154036040484
4.9719, 2383.057530704589
4.9802333333333335, 3395.8511586452764
4.98855, 3264.912896301189
4.996883333333333, 2278.0055410285145
5.005216666666667, 2971.824198792383
5.01355, 2674.546370967742
5.021883333333333, 2816.7249851101847
5.030216666666667, 3174.6166147285553
5.03855, 2797.3285693127964
5.0469, 3351.042523441355
5.055233333333334, 3681.9825379411222
5.063566666666666, 2650.213478717814
5.0719, 3242.030541153597
5.080233333333333, 2677.0074069218667
5.088566666666667, 3393.609178263751
5.0969, 3260.078926598264
5.1052333333333335, 3258.998416468725
5.113566666666666, 2716.8784494930046
5.1219, 3378.539234203297
5.130233333333333, 3287.230801335559
5.138566666666667, 3198.32024100061
5.1469, 3353.64267970812
5.155233333333333, 3028.819634079738
5.163566666666667, 2646.6825810185182
5.1719, 2702.629024176375
5.180233333333334, 3387.8484729835554
5.188566666666666, 3571.0335760517796
5.1969, 3356.955629843489
5.20525, 3777.4245864417776
5.213566666666667, 3314.9445868516286
5.221916666666667, 3353.7624035281146
5.23025, 803.5568748401943
5.238583333333334, 629.7485312797713
5.2469166666666665, 672.1073650909852
5.2552666666666665, 1281.8621134020618
5.263583333333333, 3462.759843061674
5.271933333333333, 3401.8421785764035
5.28025, 3361.480307076102
5.2886, 2838.773930987046
5.2969333333333335, 2996.6707242848447
5.305266666666666, 3156.296371239714
5.3136, 3287.895256916996
5.321933333333333, 3358.524790502793
5.330283333333333, 2875.053924505692
5.338616666666667, 3546.6883070810277
5.346933333333333, 4121.667800068004
5.355283333333333, 3643.797889258349
5.363616666666666, 3741.044859395923
5.37195, 3306.0662721123826
5.380283333333334, 3629.0930334453046
5.388616666666667, 2835.98859422407
5.39695, 3915.092140319716
5.405283333333333, 4273.519289983698
5.413616666666667, 3558.5254250268035
5.421966666666667, 3320.1185824012937
5.4303, 3687.968341562591
5.438633333333334, 3635.6691919191917
5.4469666666666665, 3224.193076833119
5.4553, 3137.613095238095
5.463633333333333, 3873.4584007055714
5.471966666666666, 3223.280079729403
5.4803, 3375.4883523416647
5.4886333333333335, 3364.114684860299
5.496966666666666, 2604.495862476603
5.5053, 2471.703480589023
5.513633333333333, 2371.9744738215345
5.521966666666667, 2697.197855750487
5.5303, 2554.6833803073005
5.53865, 2616.5671677290457
5.546983333333333, 2687.002243409983
5.555316666666666, 2758.2552383698576
5.56365, 2376.566447700859
5.571983333333334, 2002.3207436780863
5.580316666666667, 2001.4013296011199
5.58865, 1991.2843415888483
5.596983333333333, 1272.0068897637796
5.605316666666667, 1327.789455024311
5.613649999999999, 719.4885404492924
5.6219833333333336, 670.1686593422376
5.630316666666666, 1079.3610129564195
5.63865, 1647.1819756930495
5.646983333333333, 2103.6195895276937
5.655333333333333, 3180.731453663046
5.663666666666667, 2027.2688518378175
5.672, 2493.8490589400694
5.6803333333333335, 3117.3717059639393
5.688666666666666, 4285.025922537359
5.697, 3606.0677842565597
5.705333333333333, 3586.4490073958737
5.713666666666667, 3788.512804366079
5.722, 3077.3746135348674
5.730333333333333, 3283.242872807017
5.738666666666668, 2589.721269296741
5.747, 1654.820374015748
5.755333333333334, 1628.747967479675
5.7636666666666665, 1237.5255853203103
5.772, 1625.689052795031
5.780333333333333, 2634.125384894041
5.788666666666667, 3477.6408450704225
5.797, 3095.458058532564
5.8053333333333335, 2846.104826546003
5.813666666666666, 3577.605431309904
5.822, 3171.5315895597623
5.830333333333333, 1353.1552245250432
5.838666666666667, 989.2469645080946
5.847, 1917.9051043788188
5.85535, 2759.575250528638
5.863683333333333, 3620.0348163667736
5.872016666666667, 3132.675764655905
5.880350000000001, 3179.2929292929293
5.888683333333334, 3248.238871041762
5.897016666666667, 3678.9592607581276
5.90535, 2920.232016608686
5.913683333333333, 2944.1378933566434
5.922016666666667, 3573.73820754717
5.93035, 3579.049604916593
5.9386833333333335, 3388.6365030674847
5.947033333333334, 3263.0750973709837
5.9553666666666665, 2977.6019960517656
5.9637, 3364.4338217035015
5.972033333333333, 2998.3441324694027
5.980366666666667, 3693.361801242236
5.9887, 2996.4781746031745
5.99705, 3742.6982801286813
6.0053833333333335, 3157.337105812548
6.013716666666666, 3026.689848080476
6.022049999999999, 2852.26488657845
6.030383333333333, 3431.3594470046082
6.038716666666667, 2893.09875403784
6.04705, 3531.1073808562196
6.0554, 2474.4802167338707
6.063716666666667, 3605.600980201863
6.072066666666666, 3389.370598591549
6.0804, 2965.0826848249026
6.088733333333334, 2664.99529822676
6.097066666666667, 2970.6858185818583
6.1054, 2802.4877029021154
6.113733333333333, 2923.236692015209
6.122066666666667, 2894.6901688664593
6.1304, 1612.4788767395626
6.138733333333334, 1299.762969743023
6.147049999999999, 1244.1548542920495
6.1554, 1695.5098835869064
6.163716666666667, 1532.2845520289272
6.17205, 2255.7352418207684
6.180383333333333, 2235.986233598623
6.188716666666667, 1556.8258123591283
6.19705, 1260.2410926807497
6.205383333333334, 1526.020264847512
6.2137166666666666, 1562.6441663476262
6.22205, 1430.2937101108498
6.2304, 1032.9709558823529
6.238716666666667, 922.7787712785223
6.24705, 920.5269544894186
6.2553833333333335, 1407.4160888748818
6.263716666666666, 1522.7264393105975
6.272049999999999, 2104.3414634146343
6.2804, 2500.648982197319
6.288716666666667, 2187.969268528761
6.297066666666667, 3001.041369472183
6.3054, 2146.261316155989
6.313733333333333, 1904.5801260597946
6.322066666666666, 1311.0088470319633
6.3304, 1561.2396599264707
6.338733333333334, 1858.8605182926829
6.347066666666667, 2217.7593230443135
6.3554, 2385.5635859249523
6.363733333333333, 2838.4380360205832
6.372066666666667, 2746.5495937002597
6.3804, 2667.8837647444298
6.388733333333334, 2304.020029951329
6.3970666666666665, 2443.186133932724
6.4054, 2636.4604078706284
6.413733333333332, 2555.619872199432
6.422066666666667, 2236.574041872435
6.4304, 2435.155149403129
6.438716666666667, 2535.1254958803784
6.44705, 2310.6603119584056
6.4554, 2617.9150556300797
6.463733333333334, 2523.3794188260617
6.472066666666667, 2242.35576224386
6.4804, 2407.1747399472133
6.488733333333333, 2374.3484695350853
6.497066666666667, 2329.99094009806
6.5054, 2602.2501929012346
6.513733333333334, 2927.497041170006
6.5220666666666665, 2555.7514327757126
6.5304, 2126.4709201109035
6.538733333333332, 2134.122455274522
6.547066666666667, 2449.0788468881256
6.5554, 2563.2393525770117
6.563733333333333, 2573.78232376904
6.572066666666666, 2063.702613837312
6.5804, 1231.3473259582863
6.588733333333334, 1434.917297166774
6.597066666666667, 1821.4443483545251
6.6054, 1135.6019295302015
6.613733333333333, 1210.8329824350337
6.622066666666667, 958.7095915602014
6.630416666666667, 1076.1774039541676
6.638733333333334, 1280.1190703902066
6.6470666666666665, 1563.665546363323
6.6554, 2181.780250347705
6.663733333333332, 2168.1464502018844
6.672066666666667, 1980.8406832927817
6.6804, 1669.8519080855692
6.688733333333333, 2094.433868322399
6.697066666666666, 2700.393149504524
6.7054, 2410.740779991522
6.713733333333334, 2748.044886193471
6.722066666666667, 2790.9520905923346
6.7304, 1567.1018204599056
6.738733333333333, 2060.189488071571
6.747066666666667, 2630.9693020651903
6.7554, 2445.580768010155
6.763733333333334, 2387.4952156162285
6.7720666666666665, 2326.5987487318225
6.7804, 2082.892957594115
6.788733333333332, 1801.8506129143648
6.797066666666667, 2487.1446395855705
6.805416666666667, 2337.687742248062
6.81375, 2193.518399050372
6.8220833333333335, 2456.804677278674
6.830416666666666, 1390.7959692028985
6.83875, 1222.0980703074608
6.847066666666667, 1178.9506244817578
6.855416666666667, 2336.4219524560613
6.86375, 2644.2821421391236
6.872083333333333, 1701.226872040867
6.880416666666667, 1169.3062153186481
6.88875, 1159.082702888583
6.897083333333334, 1331.7430033522958
6.9054166666666665, 2248.7820424476295
6.913750000000001, 2753.269726733977
6.922083333333333, 2649.1608555370526
6.930416666666667, 2752.0470520352496
6.93875, 2766.9538253871233
6.9470833333333335, 2340.1899240761068
6.955433333333334, 2872.279747979583
6.963766666666666, 2944.173246078847
6.9721, 2705.8661488439307
6.980433333333333, 2550.57529455081
6.988766666666667, 2704.5023696682465
6.9971, 3199.1384408602153
7.005433333333333, 2879.417782738095
7.013766666666666, 3006.8505747126437
7.0221, 2509.99446290144
7.03045, 2677.8819564465953
7.038783333333333, 1750.0135265559195
7.047116666666667, 1998.3066739800759
7.0554499999999996, 2867.633507730015
7.063783333333333, 3304.617139959432
7.072116666666667, 3115.580301616915
7.08045, 2947.6404494382023
7.088783333333334, 2551.0569852941176
7.0971166666666665, 2702.986765772299
7.10545, 2733.7554190751443
7.113783333333333, 3155.0709402226526
7.122116666666667, 3836.8804476288965
7.13045, 3630.2188687753655
7.1387833333333335, 2941.241197183099
7.147116666666666, 2205.566623424759
7.15545, 2152.808035714286
7.163783333333333, 1871.3494516016715
7.1722166666666665, 1773.7933753943216
7.1805666666666665, 1722.4738414047467
7.188883333333333, 1599.5831997435075
7.197216666666667, 1925.4584514528701
7.205566666666667, 1798.0793153740565
7.2139, 1599.100957240763
7.2222333333333335, 1782.5621662216288
7.230566666666666, 1832.9310897435898
7.2389, 1927.859349258649
7.247233333333333, 2148.1943982712764
7.255566666666667, 1884.3233512516044
7.263899999999999, 1937.9587155963302
7.272233333333333, 1951.5420751633987
7.280566666666667, 2157.6293734918995
7.2889, 1905.9739130434782
7.297233333333334, 1980.0760248655913
7.3055666666666665, 1984.969793497364
7.3139, 1482.2072360010227
7.322233333333333, 1137.372352496218
7.330566666666667, 820.7714476160603
7.338883333333333, 766.8593617150492
7.347216666666666, 1004.7112819279215
7.35555, 2162.913158366177
7.363883333333333, 1870.2974449415003
7.372216666666666, 1594.5661201022147
7.38055, 1653.1307541011047
7.388883333333333, 1487.793869084204
7.397216666666667, 1412.6470759552656
7.405566666666667, 1400.497293773704
7.413883333333334, 1732.974119777628
7.4222166666666665, 1721.736596736597
7.4305666666666665, 1145.2362565445026
7.438883333333333, 760.3716637864824
7.447233333333333, 638.0930722891567
7.455566666666667, 785.2887759573895
7.4639, 998.821328596038
7.4722333333333335, 1071.2281028956677
7.480566666666666, 1752.5630533013648
7.4889, 2173.145715440582
7.497216666666666, 2563.8237569355524
7.50555, 2996.066460828343
7.513883333333333, 3024.1933297180044
7.522233333333333, 1731.7643229166665
7.530566666666667, 807.893316127673
7.5389, 502.7691519802302
7.5472166666666665, 419.87010360316845
7.55555, 440.1813431291391
7.5639, 378.2989365626994
7.572233333333333, 463.3782908688803
7.580566666666667, 547.3464156079855
7.5889, 682.3021667160787
7.5972333333333335, 918.5700055920593
7.605566666666666, 1202.5613296309893
7.6139, 1312.3816098560578
7.622233333333333, 1129.345515633571
7.630566666666667, 945.941162109375
7.638883333333333, 1003.240512904637
7.647216666666667, 940.8437824122092
7.655566666666667, 1103.5841546626232
7.6639, 860.9449683503423
7.672233333333334, 820.3727545429325
7.6805666666666665, 923.1574686752076
7.6889, 827.3518509736975
7.697233333333333, 899.736922260651
7.705566666666667, 786.2752072250402
7.7139, 876.0120819972515
7.7222333333333335, 799.1324921135647
7.730566666666666, 888.7230294845092
7.7389, 691.6613389182834
7.747233333333333, 938.6474475452551
7.755566666666667, 739.6739223547149
7.763916666666668, 1003.1550218340611
7.77225, 900.3975504127757
7.780583333333333, 621.9946878279119
7.788916666666666, 624.334999553691
7.79725, 535.9931612505142
7.805583333333334, 578.945614676981
7.813916666666667, 831.9540367853449
7.82225, 1135.3226336546888
7.830583333333333, 1569.198689153871
7.838916666666667, 1705.867495345951
7.84725, 1476.8037795403045
7.855583333333334, 1399.1249597682652
7.8639, 1540.188345496618
7.87225, 1732.5463570725306
7.880583333333333, 1853.688233202986
7.888916666666668, 1703.2325042158516
7.89725, 1591.6163938575767
7.905583333333333, 1450.9710590169068
7.913916666666666, 1584.5777936055715
7.92225, 1499.516200711054
7.930583333333334, 1336.980403800475
7.938916666666667, 1242.624482520699
7.94725, 1466.4722074062786
7.955583333333333, 1406.1884803137004
7.963916666666667, 1396.8778625954199
7.97225, 1120.6435079726652
7.980583333333334, 921.9419682065695
7.988916666666666, 712.1434043484605
7.99725, 640.8542372187022
8.005583333333334, 637.6005577787523
8.013916666666667, 486.89942869630374
8.02225, 385.58582560360117
8.0306, 363.2683183504566
8.038933333333333, 329.414762972148
8.047266666666667, 288.5663621427311
8.0556, 303.7817365235781
8.063933333333333, 310.379691572988
8.072266666666666, 277.5058380164034
8.0806, 287.12067679073033
8.088933333333333, 276.790988869863
8.097266666666666, 296.22018169083714
8.1056, 280.8885954815841
8.113933333333334, 321.7085040983607
8.122266666666667, 279.562255859375
8.1306, 290.01319809715346
8.138933333333334, 256.6896083320089
8.147266666666667, 286.6018068013496
8.1556, 244.3959296969013
8.163933333333333, 290.8692266202888
8.172266666666667, 258.3905598783275
8.1806, 239.0130651505943
8.188933333333333, 227.85935669985093
8.197266666666666, 226.4024013488606
8.205616666666666, 220.02685351092623
8.21395, 229.53549060542798
8.222283333333333, 251.92475888804842
8.230616666666666, 323.4665117170969
8.23895, 452.22948194961106
8.247283333333334, 717.0440051020408
8.255616666666667, 1262.4903350515463
8.26395, 1522.547058596166
8.272283333333334, 1522.652108184228
8.280616666666667, 1564.1088317995911
8.28895, 1432.4152153145208
8.297283333333333, 1398.9390257685352
8.305633333333333, 1585.0310114503816
8.313966666666667, 1212.7740139046537
8.3223, 1320.4661112786491
8.330633333333333, 1481.618685609837
8.338966666666666, 1445.836759868421
8.3473, 1551.434645087085
8.355633333333333, 1978.2780439411538
8.363966666666666, 1749.7427812811152
8.3723, 1981.3372687655637
8.380633333333334, 2101.8409653465346
8.388966666666667, 2047.9775528169016
8.3973, 1747.4256261114404
8.405633333333334, 2031.6070370683817
8.413966666666667, 1552.0776976254886
8.4223, 1295.1224328593996
8.430633333333333, 1231.1247810378804
8.438966666666667, 814.5236036739551
8.4473, 631.433789135587
8.455633333333333, 627.2566558621454
8.463966666666666, 541.313209494324
8.4723, 673.5384676903391
8.480633333333333, 587.2185698847262
8.48895, 603.9320463895205
8.497283333333334, 514.9810964083176
8.505633333333334, 522.4375745891857
8.513966666666667, 517.980901835775
8.5223, 513.4609092960288
8.530633333333334, 500.5263241123387
8.538966666666665, 526.977407473949
8.5473, 548.2121805149485
8.555633333333333, 613.1984988931931
8.563966666666667, 507.5435606060606
8.5723, 486.77408550792165
8.580633333333333, 541.3154489806642
8.588966666666666, 508.9671668502202
8.5973, 511.98865943336637
8.605633333333333, 467.303181800376
8.613966666666666, 495.6541321680466
8.6223, 425.1532157277447
8.630633333333334, 474.9067651497562
8.638966666666667, 541.73893668346
8.6473, 652.561250274665
8.655633333333334, 867.4820257785725
8.663966666666665, 823.2572739065974
8.6723, 1249.4321811909022
8.680633333333333, 1648.48687267658
8.688966666666667, 1643.4815573770493
8.6973, 1484.29383748056
8.705633333333333, 1314.4527908468776
8.713966666666666, 1558.726111544462
8.7223, 1468.8040611814345
8.730633333333333, 1226.078431372549
8.73895, 1230.570652173913
8.7473, 1123.3574001889913
8.755633333333334, 1155.8029140235615
8.76395, 1161.0842759531465
8.7723, 910.4655774111675
8.780633333333334, 1013.2315638075313
8.78895, 1126.4993320167287
8.797283333333333, 1114.8351295868617
8.805633333333333, 1289.3652608401085
8.81395, 1128.0151305876443
8.8223, 1375.0882461188437
8.830633333333333, 1341.7352407651715
8.83895, 1473.1290494899365
8.847283333333333, 1429.278726493363
8.855633333333333, 1279.4148751733703
8.863966666666666, 1548.7942624155157
8.8723, 1437.3927471399238
8.880633333333334, 985.2183749062266
8.888966666666667, 781.2048840423898
8.8973, 721.7736964097843
8.905633333333334, 645.5935707053662
8.913966666666665, 666.8396233360819
8.9223, 647.0367091921084
8.930633333333333, 663.8913170163171
8.938966666666667, 1015.780029296875
8.9473, 608.0807690144014
8.955633333333333, 663.3415866346538
8.963966666666666, 792.3329028541698
8.9723, 635.4855029193205
8.980633333333333, 631.4098639026361
8.98895, 518.8142627925254
8.9973, 468.01268793254314
9.005633333333334, 565.1019029509322
9.013966666666667, 527.1214681969276
9.0223, 504.58031429378
9.030633333333334, 604.2546299102812
9.03895, 802.1922980341512
9.047283333333333, 1124.3143562974542
9.055616666666667, 1088.206449468085
9.06395, 1244.6228605243991
9.072283333333333, 1372.8761033229491
9.080616666666666, 1273.8871308016876
9.08895, 1191.5982967307214
9.097283333333333, 1427.5238709227767
9.105616666666666, 1483.27760458568
9.11395, 1325.1219471728166
9.1223, 1372.6198163920692
9.130633333333334, 1398.1327243417518
9.138966666666667, 1316.2578599306157
9.1473, 1345.923271793448
9.155633333333334, 1265.4632890815496
9.163966666666665, 1143.0112508755544
9.1723, 987.0630592841163
9.180633333333333, 900.6393226760304
9.188966666666667, 646.2644224126019
9.1973, 832.73167686232
9.205633333333333, 753.1391340822877
9.21395, 625.4156014927128
9.2223, 657.8298065089566
9.230633333333333, 613.2076219863883
9.23895, 627.8583242776783
9.247283333333334, 678.978105890428
9.255616666666667, 852.9421722643553
9.26395, 689.0665400775695
9.2723, 832.351013711688
9.280616666666667, 716.3918334464043
9.28895, 805.7603441999677
9.2973, 787.1556772834762
9.305633333333333, 741.6154929342755
9.313966666666667, 746.620027239326
9.3223, 683.5291916167664
9.330633333333333, 631.0480791823308
9.338966666666666, 584.3676747165285
9.3473, 607.9802840655664
9.355633333333333, 623.7246621621622
9.363966666666666, 683.8141232717405
9.3723, 727.4511523827346
9.380633333333334, 786.0370686975443
9.388966666666667, 941.3122699514806
9.3973, 1062.2857572744401
9.405633333333334, 1159.705628673652
9.413966666666665, 1414.2901223526046
9.4223, 1269.008819018405
9.430633333333333, 1351.3685175484547
9.438966666666667, 1235.5679024327123
9.4473, 1194.5944216990788
9.45565, 1210.3728437577563
9.463983333333333, 1136.474877597325
9.472316666666666, 1148.5954919626654
9.48065, 1155.928199404762
9.488966666666666, 1229.255037568306
9.4973, 1265.8972897669705
9.50565, 1202.7779893954169
9.513966666666667, 1190.6934218950064
9.522316666666667, 1228.2863959580839
9.53065, 1208.2945142748863
9.538966666666665, 1274.6503753263707
9.5473, 1353.2873163693598
9.555649999999998, 1394.65679741051
9.563983333333333, 1324.843668577384
9.5723, 1327.8740727485683
9.58065, 1088.566598851125
9.588966666666666, 1256.639718677494
9.597316666666666, 1258.8981248298394
9.60565, 1132.3573950505313
9.613983333333334, 1060.3296503156873
9.622316666666666, 1216.5922070744289
9.63065, 1284.720222513089
9.638983333333334, 1166.0155233012235
9.647316666666667, 1098.8168311151906
9.655666666666667, 1080.9522710487445
9.663983333333332, 1297.8705609881627
9.672316666666667, 1251.0150735294117
9.680649999999998, 1040.8252441638876
9.688983333333333, 1208.5136316241412
9.697316666666667, 1076.6004480075453
9.70565, 1008.6531988995552
9.713983333333333, 1071.3765194740758
9.722316666666666, 1215.2873426739493
9.73065, 1170.2818396226417
9.738983333333334, 1058.3411235754986
9.747316666666666, 1120.0338591940153
9.75565, 1092.7299941588785
9.763983333333334, 1268.5345358286136
9.772316666666667, 1419.702141786979
9.78065, 1203.1693262411347
9.788983333333332, 1131.2280244338497
9.797316666666667, 1150.884726821192
9.805649999999998, 965.2196596746575
9.813983333333333, 1205.9708500946522
9.822333333333331, 1348.2108097586297
9.830666666666668, 1168.7397155618241
9.838983333333333, 1057.518394934976
9.847316666666666, 1322.70292721519
9.855666666666666, 1345.1933874486654
9.863983333333334, 1260.5260259315207
9.872316666666666, 1110.9806885488647
9.880666666666666, 1200.351393560788
9.888983333333334, 1407.1238132911392
9.897316666666667, 1029.7090382205513
9.90565, 1265.0514013324143
9.914, 1238.8292800985685
9.922333333333333, 1165.1819655635063
9.930666666666667, 1249.9266164486382
9.939, 984.3689649622953
9.947333333333331, 898.7177702145214
9.955683333333333, 1003.914196773062
9.964, 967.0204829083016
9.97235, 956.7699399656947
9.980683333333333, 858.9383500711688
9.989, 764.7998303793963
9.997333333333334, 747.0852222872185
##END=$$ End of the data block

`;

export default hplcMsTicNegJcamp;
